// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"4e634199","185":"67e101d7","776":"e5348606","810":"55888d2b"}[chunkId] + ".chunk.js";
};